import FormControlLabel from "designSystem/components/form/FormControlLabel";
import Slider from "designSystem/components/slider/Slider";
import React, { useState } from "react";

export default () => {
	const [value, setValue] = useState(20);

	const onChangeValue = (value: number) => {
		setValue(value);
	};

	return (
		<FormControlLabel
			block
			control={(
				<Slider
					includeTextField
					max={100}
					min={0}
					onChange={onChangeValue}
					spacingAround={2}
					step={1}
					value={value}
				/>
			)}
			label="Label"
			labelPlacement="start"
			sx={{
				"& .MuiBox-root": {
					paddingLeft: 4,
					paddingRight: 4,
				},
				"&.MuiFormControlLabel-root>div:first-of-type": {
					marginLeft: 0,
				},
			}}
		/>

	);
};